/**
 * Spawned (child) AFP — CO Points withdrawal: direct referrals + team (L7+).
 */

const CHILD_AFP_REQUIRED_DIRECTS_BY_LEVEL = {
  1: 0,
  2: 1,
  3: 2,
  4: 5,
  5: 10,
  6: 15,
  7: 20,
  8: 30,
  9: 40,
  10: 50,
  11: 60,
  12: 70,
  13: 80,
  14: 90,
  15: 100,
};

const CHILD_AFP_TEAM_BY_LEVEL = {
  7: { minTotal: 50, depth: 2, memberKind: "active_afp" },
  8: { minTotal: 250, depth: 3, memberKind: "active_afp" },
  9: { minTotal: 1000, depth: 4, memberKind: "active_afp" },
  10: { minTotal: 3000, depth: 5, memberKind: "active_afp" },
  11: { minTotal: 6000, depth: 6, memberKind: "active_afp" },
  12: { minTotal: 12000, depth: 7, memberKind: "active_afp" },
  13: { minTotal: 25000, depth: 8, memberKind: "active_afp" },
  14: { minTotal: 50000, depth: 9, memberKind: "active_afp" },
  15: { minTotal: 100000, depth: 10, memberKind: "active_afp" },
};

export function getChildAfpRequiredDirectReferralsForLevel(level) {
  const L = Number(level);
  if (L < 1 || L > 15) return 0;
  return CHILD_AFP_REQUIRED_DIRECTS_BY_LEVEL[L] ?? 0;
}

export function getChildAfpTeamWithdrawalRules(level) {
  const L = Number(level);
  const row = CHILD_AFP_TEAM_BY_LEVEL[L];
  if (!row) return null;
  return {
    minTotal: row.minTotal,
    maxPerLeg: Math.floor(row.minTotal / 2),
    depth: row.depth,
    memberKind: row.memberKind,
  };
}

export function getChildAfpRequiredTeamSizeForLevel(level) {
  const rules = getChildAfpTeamWithdrawalRules(level);
  return rules ? rules.minTotal : 0;
}

export function describeChildAfpWithdrawalRules(trancheLevel) {
  const L = Number(trancheLevel);
  const lines = [];
  if (L < 1 || L > 15) return lines;

  const directs = getChildAfpRequiredDirectReferralsForLevel(L);
  if (L === 1) {
    lines.push("Level 1: no conditions.");
  } else if (directs > 0) {
    lines.push(`${directs} direct referral(s) with active ₹150 Auto Fill program.`);
  }

  const teamRules = getChildAfpTeamWithdrawalRules(L);
  if (teamRules) {
    lines.push(
      `Team size ${teamRules.minTotal}: active AFP at depth ${teamRules.depth}; max ${teamRules.maxPerLeg} per level-1 leg (50% cap).`
    );
  }

  if (L > 1) {
    lines.push(
      `Complete prior child withdrawals (levels 1–${L - 1}) for this Program ID before level ${L}.`
    );
  }
  return lines;
}
